<template>
  <ModalDialog
    ref="dialog"
    title="Close Credit Note"
    icon="fa-check-circle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Close"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will manually close the credit note and mark it as credited</NotificationBarTitle>
        <ul>
          <li>This is a manual process to flag credit notes as credited and close them off.</li>
          <li>Invoice allocations will <strong>NOT</strong> match the total credit note amount.</li>
          <li>The remaining credit available will be set to {{formatCurrency(0)}} and the credit note will no longer be available for further allocations.</li>
        </ul>

        <template v-if="hasXeroIntegration">
          <strong>Xero Users</strong>
          <ul>
            <li>After closing an credit note, please access Xero to ensure the linked credit note is manually closed too</li>
          </ul>
        </template>
      </NotificationBar>
      
      <FormRow label="Closing Reason">
        <FormInputTextArea ref="textEntryArea" v-model="closeReason" placeholder="Enter reason and details for closing the credit note" field="reason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'CreditNoteCloseDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    creditNoteId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      closeReason: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        reason: this.closeReason
      }

      this.$apiService.accountsService.closeCreditNote(this.creditNoteId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>